export default __webpack_public_path__ + "static/media/second-step-zweifamilienhaus.9a6e0509.svg";